import { Component, OnInit } from '@angular/core';
@Component({ templateUrl: './content.component.html' })
export class ResourceSupportComponent implements OnInit {
  list = [];
  ngOnInit(): void {
    this.loadList();
  }

  private loadList(){
    this.list.push({'title':'API Document', 'link':'http://payres.intelligent-earnings.com/docs/pay_document.html', 'remark':''});
    this.list.push({'title':'Country Code List', 'link':'https://www.nationsonline.org/oneworld/country_code_list.htm', 'remark':''});
    this.list.push({'title':'TimeZone ID List', 'link':'https://en.wikipedia.org/wiki/List_of_tz_database_time_zones', 'remark':''});
    this.list.push({'title':'Currency Code List', 'link':'https://www.countries-ofthe-world.com/world-currencies.html', 'remark':''});
    this.list.push({'title':'Language Code List', 'link':'https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes', 'remark':''});
    //this.list.push({'title':'', 'link':'', 'remark':''});
  }

}
